<div class="dashboard-container">
  <!-- Header -->
  <app-staff-header 
    [currentUser]="currentUser" 
    (logout)="onLogout()">
  </app-staff-header>

  <!-- Main Content -->
  <div class="dashboard-content">
    <!-- Navigation -->
    <app-staff-nav 
      [isMobileMenuOpen]="isMobileMenuOpen"
      (navigate)="onNavigate($event)"
      (closeMobileMenu)="closeMobileMenu()">
    </app-staff-nav>

    <!-- Content Area -->
    <div class="dashboard-main">
      <div class="main-content">
        <!-- Page Header -->
        <div class="content-header">
          <h1 class="page-title">จัดการ CPD Hours</h1>
          <p class="page-subtitle">ระบบจัดการชั่วโมงการศึกษาต่อเนื่อง (Continuing Professional Development)</p>
        </div>

        <!-- Error Alert -->
        <ngb-alert 
          *ngIf="error" 
          type="danger" 
          [dismissible]="true"
          class="mb-3">
          {{ error }}
        </ngb-alert>

        <!-- Filters Section -->
        <div class="filters-section">
          <div class="filters-header">
            <h3>ตัวกรอง</h3>
            <button 
              type="button" 
              class="clear-filters-btn" 
              (click)="clearFilters()">
              ล้างตัวกรอง
            </button>
          </div>
          
          <div class="filters-grid">
            <!-- Search Term -->
            <div class="filter-group">
              <label class="form-label">ค้นหาทั่วไป</label>
              <input 
                type="text" 
                class="form-control" 
                [(ngModel)]="filters.searchTerm" 
                (ngModelChange)="applyFilters()"
                placeholder="อีเมล, CID, หัวข้อคอร์ส">
            </div>

            <!-- Email -->
            <div class="filter-group">
              <label class="form-label">อีเมล</label>
              <input 
                type="text" 
                class="form-control" 
                [(ngModel)]="filters.email" 
                (ngModelChange)="applyFilters()"
                placeholder="อีเมลผู้ใช้">
            </div>

            <!-- CID -->
            <div class="filter-group">
              <label class="form-label">เลขบัตรประชาชน</label>
              <input 
                type="text" 
                class="form-control" 
                [(ngModel)]="filters.cid" 
                (ngModelChange)="applyFilters()"
                placeholder="เลขบัตรประชาชน">
            </div>

            <!-- Course Title -->
            <div class="filter-group">
              <label class="form-label">หัวข้อคอร์ส</label>
              <input 
                type="text" 
                class="form-control" 
                [(ngModel)]="filters.courseTitle" 
                (ngModelChange)="applyFilters()"
                placeholder="ชื่อคอร์ส">
            </div>

            <!-- Verification Status -->
            <div class="filter-group">
              <label class="form-label">สถานะการยืนยัน</label>
              <select 
                class="form-select" 
                [(ngModel)]="filters.isVerified" 
                (ngModelChange)="applyFilters()">
                <option value="all">ทั้งหมด</option>
                <option value="verified">ยืนยันแล้ว</option>
                <option value="unverified">รอยืนยัน</option>
              </select>
            </div>

            <!-- Payment Status -->
            <div class="filter-group">
              <label class="form-label">สถานะการชำระเงิน</label>
              <select 
                class="form-select" 
                [(ngModel)]="filters.paymentStatus"
                (ngModelChange)="applyFilters()">
                <option value="">ทั้งหมด</option>
                <option *ngFor="let s of cpdPaymentStatusList" [value]="s.id">{{ s.name }}</option>
              </select>
            </div>

            <!-- Year Filter -->
            <div class="filter-group">
              <label class="form-label">ปี</label>
              <input 
                type="number" 
                class="form-control" 
                [(ngModel)]="filters.yearFilter" 
                (ngModelChange)="applyFilters()"
                placeholder="ปี พ.ศ."
                min="2500"
                max="2600">
            </div>

            <!-- Date From -->
            <div class="filter-group">
              <label class="form-label">วันที่เริ่มต้น</label>
              <input 
                type="date" 
                class="form-control" 
                [(ngModel)]="filters.dateFrom" 
                (ngModelChange)="applyFilters()">
            </div>

            <!-- Date To -->
            <div class="filter-group">
              <label class="form-label">วันที่สิ้นสุด</label>
              <input 
                type="date" 
                class="form-control" 
                [(ngModel)]="filters.dateTo" 
                (ngModelChange)="applyFilters()">
            </div>
          </div>

          <!-- Action Buttons -->
          <div class="d-flex gap-2 mt-3">
            <button 
              type="button" 
              class="btn btn-outline-success" 
              (click)="exportToCSV()"
              [disabled]="filteredRecords.length === 0">
              <i class="bi bi-file-earmark-excel me-2"></i>Export CSV
            </button>
            <button 
              type="button" 
              class="btn btn-primary" 
              (click)="refreshData()">
              <i class="bi bi-arrow-clockwise me-2"></i>รีเฟรชข้อมูล
            </button>
          </div>
        </div>

        <!-- Status Tabs -->
        <div class="status-tabs mb-3" role="tablist" aria-label="สถานะใบคำขอสมัครคอร์สอบรม/สัมมนา">
          <button type="button" class="status-tab" *ngFor="let tab of statusTabs"
            [class.active]="isActiveStatusTab(tab)"
            [ngClass]="'status-tab-' + tab.color"
            role="tab" [attr.aria-selected]="isActiveStatusTab(tab)"
            (click)="selectStatusTab(tab)">
            <span class="status-tab-dot"></span>
            <span class="status-tab-name">{{ tab.name }}</span>
            <span class="status-tab-count">{{ tab.count }}</span>
          </button>
        </div>

        <!-- Loading Spinner -->
        <div *ngIf="isLoading" class="cpd-management-container">
          <div class="loading-state">
            <div class="loading-spinner"></div>
            <p>กำลังโหลดข้อมูล CPD Hours...</p>
          </div>
        </div>

        <!-- CPD Hours Table -->
        <div class="card" *ngIf="!isLoading">
          <div class="card-header d-flex justify-content-between align-items-center">
            <h5 class="card-title mb-0">รายการ CPD Hours</h5>
            <div class="d-flex align-items-center gap-2">
              <span class="text-muted">แสดงผล:</span>
              <select class="form-select form-select-sm w-auto" [(ngModel)]="pageSize"
                  (ngModelChange)="changePageSize(pageSize)" aria-label="จำนวนรายการต่อหน้า">
                  <option *ngFor="let size of pageSizeOptions" [ngValue]="size">{{ size }} รายการ</option>
                </select>
            </div>
          </div>

          <div class="card-body p-0">
            <!-- Table -->
            <div class="table-responsive">
              <table class="table table-striped table-hover mb-0">
                <thead class="table-light">
                  <tr>
                    <th scope="col" class="sortable" (click)="sortBy('createdAt')"
                      [class.sorted]="isSortedBy('createdAt')" title="คลิกเพื่อเรียงลำดับ">
                      วันและเวลาที่ยื่นคำขอ {{ getSortIcon('createdAt') }}
                    </th>
                    <th scope="col" class="sortable" (click)="sortBy('email')"
                      [class.sorted]="isSortedBy('email')" title="คลิกเพื่อเรียงลำดับ">
                      Email {{ getSortIcon('email') }}
                    </th>
                    <th scope="col" class="sortable" (click)="sortBy('fullName')"
                      [class.sorted]="isSortedBy('fullName')" title="คลิกเพื่อเรียงลำดับ">
                      ชื่อ-นามสกุล {{ getSortIcon('fullName') }}
                    </th>
                    <th scope="col" class="sortable text-center" (click)="sortBy('memberNo')"
                      [class.sorted]="isSortedBy('memberNo')" title="คลิกเพื่อเรียงลำดับ">
                      เลขที่สมาชิก {{ getSortIcon('memberNo') }}
                    </th>
                    <th scope="col" class="sortable text-center" (click)="sortBy('valuerNo')"
                      [class.sorted]="isSortedBy('valuerNo')" title="คลิกเพื่อเรียงลำดับ">
                      เลขที่ผู้ประเมินหลัก {{ getSortIcon('valuerNo') }}
                    </th>
                    <th scope="col" class="sortable" (click)="sortBy('courseTitle')"
                      [class.sorted]="isSortedBy('courseTitle')" title="คลิกเพื่อเรียงลำดับ">
                      หัวข้อหลักสูตร {{ getSortIcon('courseTitle') }}
                    </th>
                    <th scope="col" class="sortable text-center" (click)="sortBy('hoursStudied')"
                      [class.sorted]="isSortedBy('hoursStudied')" title="คลิกเพื่อเรียงลำดับ">
                      จำนวน CPD {{ getSortIcon('hoursStudied') }}
                    </th>
                    <th scope="col" class="sortable" (click)="sortBy('studyDate')"
                      [class.sorted]="isSortedBy('studyDate')" title="คลิกเพื่อเรียงลำดับ">
                      วันที่อบรมสัมมนา {{ getSortIcon('studyDate') }}
                    </th>
                    <th scope="col" class="sortable text-end" (click)="sortBy('price')"
                      [class.sorted]="isSortedBy('price')" title="คลิกเพื่อเรียงลำดับ">
                      ราคา {{ getSortIcon('price') }}
                    </th>
                    <th scope="col" class="sortable text-center" (click)="sortBy('paymentSlip')"
                      [class.sorted]="isSortedBy('paymentSlip')" title="คลิกเพื่อเรียงลำดับ">
                      หลักฐานการโอน {{ getSortIcon('paymentSlip') }}
                    </th>
                    <th scope="col" class="sortable text-center" (click)="sortBy('paymentStatus')"
                      [class.sorted]="isSortedBy('paymentStatus')" title="คลิกเพื่อเรียงลำดับ">
                      สถานะการชำระเงิน {{ getSortIcon('paymentStatus') }}
                    </th>
                    <th scope="col" class="sortable text-center" (click)="sortBy('receiptStatus')"
                      [class.sorted]="isSortedBy('receiptStatus')" title="คลิกเพื่อเรียงลำดับ">
                      สถานะการออกใบเสร็จ {{ getSortIcon('receiptStatus') }}
                    </th>
                    <th scope="col">หมายเหตุ</th>
                  </tr>
                </thead>
                <tbody>
                  <!-- No Data Row -->
                  <tr *ngIf="!isLoading && getCurrentPageRecords().length === 0">
                    <td colspan="13" class="text-center py-4">
                      <div class="text-muted">
                        <i class="bi bi-inbox"></i>
                        <p class="mb-0">ไม่พบข้อมูล CPD Hours</p>
                        <small *ngIf="records.length === 0">ไม่มีข้อมูลในระบบ</small>
                        <small *ngIf="records.length > 0 && filteredRecords.length === 0">ไม่พบข้อมูลที่ตรงกับเงื่อนไขการกรอง</small>
                      </div>
                    </td>
                  </tr>

                  <!-- Record Rows -->
                  <tr *ngFor="let record of getCurrentPageRecords(); trackBy: trackByRecordId"
                    class="clickable-row"
                    (click)="viewRecord(record)"
                    style="cursor: pointer;"
                    title="คลิกเพื่อดูรายละเอียด CPD Hours">
                    <!-- วันและเวลาที่ยื่นคำขอ -->
                    <td>{{ formatDateTime(record.createdAt) }}</td>

                    <!-- Email -->
                    <td>{{ record.user.email }}</td>

                    <!-- ชื่อ-นามสกุล -->
                    <td>{{ getFullName(record) }}</td>

                    <!-- เลขที่สมาชิก -->
                    <td class="text-center"><span class="font-monospace">{{ getMemberNo(record) }}</span></td>

                    <!-- เลขที่ผู้ประเมินหลัก -->
                    <td class="text-center"><span class="font-monospace">{{ getValuerNo(record) }}</span></td>

                    <!-- หัวข้อหลักสูตร -->
                    <td>{{ record.course.title }}</td>

                    <!-- จำนวน CPD -->
                    <td class="text-center">
                      <span class="badge bg-primary">{{ record.hoursStudied }} ชม.</span>
                    </td>

                    <!-- วันที่อบรมสัมมนา -->
                    <td>{{ formatDate(record.studyDate) }}</td>

                    <!-- ราคา -->
                    <td class="text-end">{{ record.course.price | number:'1.2-2' }} บาท</td>

                    <!-- หลักฐานการโอน -->
                    <td class="text-center">
                      <button *ngIf="hasPaymentSlip(record)" type="button" class="btn btn-sm btn-outline-primary"
                        (click)="openPaymentSlip(record, $event)" title="ดูหลักฐานการโอน">
                        <i class="bi bi-image"></i>
                      </button>
                      <span *ngIf="!hasPaymentSlip(record)" class="text-muted">-</span>
                    </td>

                    <!-- สถานะการชำระเงิน -->
                    <td class="text-center">
                      <span class="badge" [ngClass]="getCpdPaymentStatusBadgeClass(record)">
                        {{ getCpdPaymentStatusName(record) }}
                      </span>
                    </td>

                    <!-- สถานะการออกใบเสร็จ -->
                    <td class="text-center">
                      <span class="badge" [ngClass]="getReceiptStatusClass(record)">
                        {{ getReceiptStatusText(record) }}
                      </span>
                    </td>

                    <!-- หมายเหตุ -->
                    <td>
                      <span [ngbTooltip]="record.notes || ''">
                        {{ record.notes ? (record.notes.length > 50 ? (record.notes.substring(0, 50) + '...') : record.notes) : '-' }}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- Pagination -->
          <div class="card-footer">
            <div class="d-flex justify-content-between align-items-center">
              <div class="text-muted">
                แสดงผล {{ ((page - 1) * pageSize) + 1 }} - {{ min(page * pageSize, collectionSize) }} 
                จาก {{ collectionSize }} รายการ
              </div>
              <ngb-pagination 
                [(page)]="page" 
                [pageSize]="pageSize" 
                [collectionSize]="collectionSize"
                [maxSize]="5"
                [rotate]="true"
                [boundaryLinks]="true"
                [size]="'sm'"
                (pageChange)="onPageChange($event)">
              </ngb-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
